import React from "react";

type RenderProps = {
  when: boolean | string | number;
  elseRender?: React.ReactNode;
  children: React.ReactNode;
};

const Render: React.FC<RenderProps> = ({ when, elseRender, children }) => {
  return !!when ? <>{children}</> : !!elseRender ? <>{elseRender}</> : null;
};

export default Render;
